import styled from 'styled-components';
export var TextContainer = styled.div.withConfig({
  displayName: "Dimensionsstyles__TextContainer",
  componentId: "sc-1u3x9hz-0"
})(["line-height:24px;"]);